module.exports = __webpack_public_path__ + "img/load-2-2.9f87da0e.png";